module.exports = __webpack_public_path__ + "ba09a6f954b6cf64da4ad6149d83e45e.jpg";